<script lang="ts" setup>
/* eslint-disable vue/no-v-html */
export type PagesOfficesDetailOpeningHoursProps = {
    data: OpeningHour[]
    note: string
}

const props = defineProps<PagesOfficesDetailOpeningHoursProps>()

const getRemainingTime = (timeEnd: string): string | false => {
    const [hours, minutes] = timeEnd.split(':')
    const currentHours = new Date().getHours()
    const currentMinutes = new Date().getMinutes()
    const hoursDiff = Number(hours) - currentHours - 1 // minus one for minutes part
    const minutesDiff = 60 - Number(minutes) - currentMinutes

    let result: string = ''

    if (hoursDiff > 0) result += `${hoursDiff}h`
    if (minutesDiff > 0) result += ` ${minutesDiff}m`

    return result
}
</script>
<template>
  <PagesOfficesDetailBox>
    <h2 class="gamma mb-2">
      {{ $t('Otváracia doba') }}
    </h2>

    <dl>
      <template
        v-for="(item, index) in props.data"
        :key="item.day"
      >
        <div
          class="row fs-bigger"
          :class="{ 'fw-bold text-black': item.is_open }"
        >
          <dt
            class="col-3"
            :class="{
              'mb-4': index < props.data.length - 1,
            }"
          >
            {{ item.day }}
          </dt>
          <dd
            class="col-9"
            :class="{
              'mb-4': index < props.data.length - 1,
            }"
          >
            {{ item.from_time }}
            <template v-if="item.to_time">
              -
            </template>
            {{ item.to_time }}
            <span
              v-if="item.is_open && item.to_time"
              class="text-green-5 d-block d-md-inline ms-md-2"
            >
              {{ $t('ešte') }}
              {{ getRemainingTime(item.to_time) }}
              {{ $t('otvorené') }}
            </span>
            <span
              v-if="
                !item.from_time &&
                  !item.to_time &&
                  !item.is_open
              "
              class="text-secondary d-block d-md-inline"
            >
              {{ $t('Zatvorené') }}
            </span>
          </dd>
        </div>
      </template>
    </dl>
  </PagesOfficesDetailBox>
</template>
